import dayjs from 'dayjs'

import { loadExternalGamesPeriodInMilliseconds } from 'shared/constants/slots'

export const isNeedUpdate = (lastTopGamesLoadDate: Date | null) =>
  !lastTopGamesLoadDate || dayjs().diff(dayjs(lastTopGamesLoadDate)) >= loadExternalGamesPeriodInMilliseconds
